import React from "react";
import { Mobile, Default } from "../../../utils/deviceHelpers";
import { Link as DomLink } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import { Typography } from "@mui/material";

const finishedJewelry = {
  title1: "Restoring a Hollow Bangle",
  link1: "/technicalarticles/",
  title2: "Sterling Silver Scrap Bracelet",
  link2: "/technicalarticles/",
  title3: "Model Making with Precision and Passion",
  link3: "/technicalarticles/",
};

export default function BarTechnicalArticles(props) {
  const ArticlesList = (list) => (
    <Stack spacing={1}>
      <Paper elevation={0} className="first-article">
        <DomLink
          to={{
            pathname: list.link1,
          }}
          target="_blank"
          className="article-title-text"
        >
          {list.title1}
        </DomLink>
      </Paper>
      <Paper elevation={0} className="second-article">
        <DomLink
          to={{
            pathname: list.link2,
          }}
          target="_blank"
          className="article-title-text"
        >
          {list.title2}
        </DomLink>
      </Paper>
      <Paper elevation={0} className="third-article">
        <DomLink
          to={{
            pathname: list.link3,
          }}
          target="_blank"
          className="article-title-text"
        >
          {list.title3}
        </DomLink>
      </Paper>
    </Stack>
  );

  return (
    <>
      <Mobile>
        <Typography variant="h2">
          Technical Articles
          <DomLink
            to={{
              pathname: "/technicalarticles",
            }}
            target="_blank"
            className="header-link"
          >
            Search All Technical Articles
          </DomLink>
        </Typography>
        {ArticlesList(finishedJewelry)}
      </Mobile>
      <Default>
        <div className="tech-articles">
          <Typography variant="h2">
            Technical Articles
            <DomLink
              to={{
                pathname: "/technicalarticles",
              }}
              target="_blank"
              className="header-link"
            >
              Search All Technical Articles
            </DomLink>
          </Typography>
          {ArticlesList(finishedJewelry)}
        </div>
      </Default>
    </>
  );
}
